import {changeBackground, closeMenu} from "./MobileHeader";
import {closeDropdown} from "./DropdownNav";
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const bodyEl = document.querySelector('body');
const headerEl = document.querySelector('.main-header');
const searchTriggerAll = document.querySelectorAll('.main-header__search-icon');
const searchWrapperAll = document.querySelectorAll('.main-header__search-form-wrapper');

const locale = {
    bodyClass: 'search-active',
    activeClass: 'active'
};

const CLOSE = 0;
const OPEN = 1;
let state = CLOSE;

/**
 * Close all search wrapper.
 */
export const closeSearch = () => {
    enablePageScroll();

    state = CLOSE;
    bodyEl.classList.remove(locale.bodyClass);

    // Remove class for all elements, because we need support across both version desktop & mobile
    searchTriggerAll.forEach(el => el.classList.remove(locale.activeClass));
    searchWrapperAll.forEach(el => el.classList.remove(locale.activeClass));
}

/**
 * Open all search wrapper.
 */
export const openSearch = () => {
    closeMenu();
    closeDropdown();
    disablePageScroll();
    changeBackground(true);

    state = OPEN;
    bodyEl.classList.add(locale.bodyClass);

    // Add class for all elements, because we need support across both version desktop & mobile
    searchTriggerAll.forEach(el => el.classList.add(locale.activeClass));
    searchWrapperAll.forEach(el => el.classList.add(locale.activeClass));
}

/**
 * Logic for toggle search wrapper.
 */
export const toggleSearch = () => {
    state === CLOSE ? openSearch() : closeSearch();
}

/**
 * Initial actions. Add event listener.
 */
const init = () => {
    if ( searchTriggerAll && !bodyEl.classList.contains('search') ) {
        searchTriggerAll.forEach(searchTriggerEl => {
            searchTriggerEl.addEventListener('click', toggleSearch);
        });
    }
}

/**
 * Close search if click event is out of header.
 * @param target
 */
export const hideSearchOutsideClick = ({target}) => {
    if ( !(target === headerEl || headerEl.contains(target)) ) {
        closeSearch();
    }
}

export default init;
